import { render, staticRenderFns } from "./UploadTemplateControl.vue?vue&type=template&id=df2e2968&scoped=true&"
import script from "./UploadTemplateControl.vue?vue&type=script&lang=ts&"
export * from "./UploadTemplateControl.vue?vue&type=script&lang=ts&"
import style0 from "./UploadTemplateControl.vue?vue&type=style&index=0&id=df2e2968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2e2968",
  null
  
)

export default component.exports